import { Observable, firstValueFrom, from } from 'rxjs';

import { DexieService } from './dexieService';
import { EssayConfigAir } from '../model/essayConfigAir';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { OnlineService } from './online.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class EssayConfigAirService {

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {
    }

    findConfigByEssayIdAndEquipmentId(idEquipment: number, idEssay: number): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + `/air/essay/config/equipment/${idEquipment}/${idEssay}`;

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));

        } else {
            return from(this.dexieService.essayConfig.get({ idEquipmentType: idEquipment, idEssay }).timeout(30000));
        }
    }

    findConfigByEssayIdAndRoomId(idRoom: number, idEssay: number): Observable<any> {

        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + `/air/essay/config/room/${idRoom}/${idEssay}`;

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));

        } else {
            return from(this.dexieService.essayConfig.get({ idRoom, idEssay }).timeout(30000));
        }
    }

    findConfigByEssayIdAndCompressedGasId(idCompressedGas: number, idEssay: number): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + `/air/essay/config/compressedGas/${idCompressedGas}/${idEssay}`;

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));

        } else {
            return from(this.dexieService.essayConfig.get({ idCompressedGas, idEssay }).timeout(30000));
        }
    }

    findAll(): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + '/air/essay/config';

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.essayConfig.toArray().timeout(30000));
        }
    }

   async saveEssayConfigToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAll());
        if (!res) return;

        await this.dexieService.essayConfig.clear();

        await Promise.all(res.map(data => this.dexieService.essayConfig.put(data, data.id)));
    }
}
